import { CreateFinancialEntity } from "./create-financial-entity.model";
import { FinancialEntity } from "./financial-entities.model";

export class EditFinancialEntity extends CreateFinancialEntity {
    constructor(
        public readonly id: FinancialEntity["id"],
        name: CreateFinancialEntity["name"],
        type: CreateFinancialEntity["type"],
        description: CreateFinancialEntity["description"],
        isActive: CreateFinancialEntity["isActive"],
        entity: CreateFinancialEntity["entity"],
        isShared?: CreateFinancialEntity["isShared"],
        sharedWithEntities?: CreateFinancialEntity["sharedWithEntities"],
    ) {
        super(name, type, description, isActive, entity, isShared, sharedWithEntities);
    }
}
